module.exports = __webpack_public_path__ + "static/media/turner_weiss.082447df.jpg";